import * as React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './OrderConfirmedBanner.module.scss';
import { ReactComponent as CheckmarkCircle } from '../../../../../assets/images/check-yellow-bg.svg';
import classNames from 'classnames';

export interface OrderConfirmedBannerProps {
  email?: string;
}

// Static component for supplements page/experiment
export default function OrderConfirmedBanner({ email }: OrderConfirmedBannerProps) {
  const { t } = useTranslation();
  return (
    <>
      <div className={classNames(styles.orderConfirmedBanner)}>
        <CheckmarkCircle />
        <div className={styles.text}>
          <h2 className={styles.confirmedText}>{t('your_order_is_confirmed')}</h2>
          <p className={styles.emailText}>
            {email
              ? t('be_on_the_lookout_for_an_email_at_email_for_tracking', { email })
              : t('be_on_the_lookout_for_an_email_for_tracking')}
          </p>
        </div>
      </div>
    </>
  );
}
